<template>
  <el-card class="centerList">
    <div class="shop-body">
      <div class="title">店铺介绍视频</div>
      <div class="shop-desc">
        <div>
          <span>店铺ID：</span>
          <span>{{ shop.id }}</span>
        </div>
        <div>
          <span>店铺名称：</span>
          <span>{{ shop.shopName }}</span>
        </div>
      </div>
    </div>

    <!-- 店铺视频 -->
    <div class="video-body">
      <template v-if="shop.processStepStatus != 1">
        <video
          :src="shop.videoUrl"
          class="video-content"
          muted
          autoplay
          :controls="true"
        ></video>
      </template>
      <template v-else>
        <div class="video-content">
          <img
            class="no-video"
            src="https://image.soole.com.cn/e5a179d6-81c5-4a03-9f8a-56437e03a7b4.png"
          />
        </div>
      </template>
      <!-- 按钮 -->
      <div class="video-btn">
        <template v-if="shop.processStepStatus == 1">
          <el-button
            type="primary"
            @click="
              () => {
                $router.push({
                  name: 'generateShopVideo',
                  query: { id: shop.id, name: shop.shopName, type: 1 },
                });
              }
            "
            >添加视频</el-button
          >
        </template>
        <template v-else>
          <el-button
            type="primary"
            @click="
              () => {
                $router.push({
                  name: 'generateShopVideo',
                  query: { id: shop.id, name: shop.shopName, type: 2 },
                });
              }
            "
            >修改视频</el-button
          >
        </template>
      </div>
    </div>
  </el-card>
</template>

<script>
import { digitalHumanShopGet } from "@/assets/api/aiProduct";
export default {
  data() {
    return {
      shop: {
        shopName: "",
        id: 0,
        videoUrl: "",
        processStepStatus: 0,
      },
    };
  },
  mounted() {
    this.getDigitalHumanShopInfo();
  },
  methods: {
    // 获取店铺数字人信息
    async getDigitalHumanShopInfo() {
      const res = await digitalHumanShopGet();
      if (res.code == 200) {
        this.shop = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-body {
  .title {
    font-size: 16px;
    color: #000000;
    font-weight: bold;
  }
  .shop-desc {
    display: flex;
    align-items: center;
    margin-top: 10px;
    div {
      // 选择第一个span标签
      span:first-child {
        color: #000000;
        font-weight: bold;
        font-size: 14px;
      }
      // 选择第二个span标签
      span:last-child {
        color: #787878;
        font-size: 14px;
        margin-left: 6px;
      }
    }
    // 选择第一个div
    div:first-child {
      margin-right: 174px;
    }
  }
}
.video-body {
  width: 447px;
  margin-top: 56px;
  margin-left: 56px;
  .video-content {
    width: 447px;
    height: 794px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #eef0f2;
    .no-video {
      width: 200px;
      height: 200px;
    }
  }
  .video-btn {
    width: 100%;
    text-align: center;
    margin-top: 30px;
  }
}
</style>
